<template>
    <div class="securitySearch">
        <Form ref="securityForm" :model="securityForm" :label-width="90" :rules="ruleValidate">
            <Row :gutter="16" style="padding-top: 15px;">
                <Col span="7">
                    <!-- 地区 -->
                    <FormItem :label="$t('ActionTrailSecurity.area')" prop="areaType" :label-width="60">
                        <Select v-model="securityForm.areaType" filterable
                            @on-change="changeAccount(securityForm.areaType)" :transfer="true" :placeholder="$t('ActionTrailSecurity.pleaseSelectArea')">
                            <Option :value="item.id" v-for="(item,index) in areaTypeList" v-bind:key="index">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem :label="$t('ActionTrailSecurity.account')" prop="accountIdSearchKey">
                        <Select v-model="securityForm.accountIdSearchKey" :transfer="true" filterable multiple :max-tag-count="1" @on-change="changeAccountId(securityForm.accountIdSearchKey)" :placeholder="$t('alarms.common.pleaseSelectAccount')">
                            <Checkbox v-model="singleAccountIdSearchKey" @on-change="selectAccountIdSearchKeyAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                            <Option v-for="item in accountIdList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem :label="$t('ActionTrailSecurity.region')" prop="regionSearchKey" >
                        <Select v-model="securityForm.regionSearchKey" filterable :placeholder="$t('RAM.common.PleaseSelectRegion')" :transfer="true">
                            <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Button type="primary" :loading="modal_loading" @click="search('securityForm')" style="float: right;margin-right: 10px;" v-hasPermission="['logs:security:search']">{{$t('ActionTrailSecurity.search')}}</Button>
            </Row>
            <Row :gutter="16">
                <Col span="7">
                    <FormItem :label="$t('ActionTrailSecurity.time')" prop="agentDate" :label-width="60">
                        <DatePicker :open="openPicker" v-model="securityForm.agentDate" type="datetimerange" :placeholder="$t('RAM.common.PleaseSelectTimeRange')" :transfer="true" :options="timeOptions" @on-change="handleChange" @on-open-change="openChange" @on-ok="handleOk" style="width: 100%;"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem :label="$t('ActionTrailSecurity.eventName')" prop="eventNameSearchKey">
                        <Select v-model="securityForm.eventNameSearchKey" :transfer="true" filterable multiple :max-tag-count="1" @on-change="changeEventNameSearchKey(securityForm.eventNameSearchKey)" :placeholder="$t('ActionTrailSecurity.pleaseSelectEventName')">
                            <Checkbox v-model="singleEventNameSearchKey" @on-change="selectEventNameSearchKeyAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                            <Option v-for="item in eventNameList" :value="item.name" :key="item.name">{{ item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem :label="$t('ActionTrailSecurity.eventType')" prop="eventTypeSearchKey">
                        <Select v-model="securityForm.eventTypeSearchKey" filterable placeholder="" :transfer="true">
                            <Option :value="item.eventType" v-for="item in eventTypeList" :key="item.name">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
    import TableSecurity from '../security/TableSecurity'
    var tableSecurity = TableSecurity;
    export default {
        name: 'SecuritySearch',
        data () {
            return {
                startDate:'',
                endDate:'',
                openPicker:null,
                timeOptions: {
                    disabledDate (date) {
                        let initdate = Date.now() -  90*24*60*60*1000;
                        return (date && date.valueOf() < initdate) || (date && date.valueOf() >= new Date())
                    }
                },
                singleAccountIdSearchKey:false,
                singleEventNameSearchKey:false,
                securityForm: {
                    accountIdSearchKey:[],
                    regionSearchKey:'',
                    eventNameSearchKey:[],
                    agentDate:'',
                    areaType:'',
                    eventTypeSearchKey:'Write'
                },
                areaTypeList: [{
                    id:1,
                    name:this.$t('RIAccountGroupManagement.China')
                },{
                    id:2,
                    name:this.$t('RIAccountGroupManagement.Overseas')
                }],
                accountIdList:[], //账号
                regionList:[], //区域
                eventNameList:[{
                    id:0,
                    name:'DeleteDatabase'
                },{
                    id:1,
                    name:'DeleteInstances'
                },{
                    id:2,
                    name:'DeleteDisk'
                },{
                    id:3,
                    name:'DeleteNatGateway'
                },{
                    id:4,
                    name:'DeleteBucket'
                },{
                    id:5,
                    name:'ConsoleSignin'
                },{
                    id:6,
                    name:'DeleteLoadBalancerListener'
                },{
                    id:7,
                    name:'StopInstance'
                }], //事件名称
                eventTypeList:[{
                    id:0,
                    name: this.$t('alarms.log.security.eventWriteType'),
                    eventType:'Write'
                },{
                    id:1,
                    name: this.$t('alarms.log.security.eventReadType'),
                    eventType:'Read'
                },{
                    id:2,
                    name: this.$t('alarms.log.security.eventAllType'),
                    eventType:'All'
                }], //事件类型
                modal_loading:false,
                ruleValidate: {
                    accountIdSearchKey: [
                        {required: true, type: 'array', message: this.$t('alarms.common.pleaseSelectAccount'), trigger: 'change'}
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ],
                    areaType: [
                        {required: true, message: '请选择地区', trigger: 'change', type: 'number'}
                    ],
                    agentDate: [{
                        type: 'array',
                        required: true,
                        message: "请选择时间",
                        fields: {
                            0: { required: true,  type: 'date',message: "请选择时间", trigger: 'change'},
                            1: { required: true,  type: 'date',message: '请选择时间', trigger: 'change'}
                        }
                    }],
                    eventNameSearchKey: [
                        {required: true, type: 'array', message: '请选择事件名称', trigger: 'change'}
                    ],
                    eventTypeSearchKey: [
                        { required: true, message: '请选择事件类型', trigger: 'change' }
                    ]
                }
            }
        },
        methods: {
            /**********************地区********************************/
            // 切换地区
            changeAccount: function () {
                if (this.securityForm.areaType == "" || this.securityForm.areaType == null) {
                    return;
                }
                this.securityForm.accountIdSearchKey = [];
                // 查询账号
                this.$api.account.listAccountByCloudPlatformAndAreaType({
                    "cloudPlatformType" : 1,
                    "areaType" : this.securityForm.areaType
                })
                .then(res => {
                    this.accountIdList = res.data;
                })
            },
            /**********************账号********************************/
            selectAccountIdSearchKeyAll() {
                this.securityForm.accountIdSearchKey = []
                if (this.singleAccountIdSearchKey) {
                    this.accountIdList.map((item) => {
                        this.securityForm.accountIdSearchKey.push(item.id)
                    })
                } else {
                    this.securityForm.accountIdSearchKey = []
                }
            },
            // 切换账号
            changeAccountId(val) {
                if(this.securityForm.accountIdSearchKey[0]==undefined){
                    return;
                }
                //查询地区
                this.$api.account.queryAccountRegions("accountId",this.securityForm.accountIdSearchKey[0])
                .then(res => {
                    this.regionList = res.data;
                })
                if (val.length === this.accountIdList.length&&val.length!=0) {
                    this.singleAccountIdSearchKey = true
                } else {
                    this.singleAccountIdSearchKey = false
                }
            },
            /**********************事件名称********************************/
            selectEventNameSearchKeyAll() {
                this.securityForm.eventNameSearchKey = []
                if (this.singleEventNameSearchKey) {
                    this.eventNameList.map((item) => {
                        this.securityForm.eventNameSearchKey.push(item.name)
                    })
                } else {
                    this.securityForm.eventNameSearchKey = []
                }
            },
            // 切换事件名称
            changeEventNameSearchKey(val) {
                if (val.length === this.eventNameList.length&&val.length!=0) {
                    this.singleEventNameSearchKey = true
                } else {
                    this.singleEventNameSearchKey = false
                }
            },
            openChange(){
                this.openPicker=true;
            },
            handleOk(){
                if((this.endDate-this.startDate)<30*24*60*60*1000){
                    this.openPicker=false;
                }
                else{
                    alert("时间间隔不能超过一个月，请重新选择")
                    this.openPicker=true;
                }
            },
            // 时间验证
            handleChange (val) {
                if(val[0]==""&&val[1]==""){
                    this.startDate=0;
                    this.endDate=0;
                    this.openPicker=true;
                }
                else{
                    this.startDate=(new Date(val[0])).getTime();
                    this.endDate=(new Date(val[1])).getTime();
                }
            },
            /**********************搜索********************************/
            search: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        tableSecurity.methods.showAll(this.securityForm.accountIdSearchKey,this.securityForm.regionSearchKey,this.securityForm.eventNameSearchKey,this.securityForm.eventTypeSearchKey,this.securityForm.agentDate);
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .securitySearch
    {
        background-color: #fff;
    }
    .title-label
    {
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/security/SecuritySearch.vue